@if (data.node?.parentID) {
  <div class="warning-box flex-container-vertical-center">
    <mat-icon style="padding-right: 15px">warning</mat-icon> {{ 'ultimateBeneficialOwnershipDialog.warningUpstreamUboOrdersCannotBe' | transloco }}
  </div>
}
<h2 mat-dialog-title>
  {{ 'ultimateBeneficialOwnershipDialog.requestUboReportFrom' | transloco }}
</h2>
<mat-dialog-content>
  <!-- Attestor select -->
  <div class="selection-container">
    <mat-form-field appearance="outline" class="selection-item">
      <mat-label>{{ 'ultimateBeneficialOwnershipDialog.attestor' | transloco }}</mat-label>
      <mat-select
        [disabled]="parties.length === 0"
        data-testid="attestor-dropdown"
        [placeholder]="'ultimateBeneficialOwnershipDialog.attestor' | transloco"
        [(ngModel)]="selectedParty">
        @for (party of parties; track party) {
          <mat-option
            [value]="party">
            {{ party.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="selection-container">
    <mat-form-field appearance="outline" class="selection-item">
      <mat-label>{{ 'ultimateBeneficialOwnershipDialog.riskTemplate' | transloco }}</mat-label>
      <mat-select 
      [(ngModel)]="selectedTemplate" 
      data-testid="risk-template-dropdown"
      [placeholder]="'ultimateBeneficialOwnershipDialog.riskTemplate' | transloco">
        @for (t of templates; track t) {
          <mat-option [value]="t">
            {{ t.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{ 'common.buttons.cancel' | transloco }}</button>
  <button
    mat-raised-button
    data-testid="ubo-continue-button"
    color="primary"
    [disabled]="!canContinue()"
    (click)="onContinueClick()"
    mat-dialog-close>
    {{ 'common.buttons.continue' | transloco }}
  </button>
</mat-dialog-actions>